import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  title: {
    color: 'white',
    fontFamily: 'Manrope-Regular',
  },
  wrapperHeaderItems: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '16px',
    alignItems: 'flex-end',
  },
  dateAndStatus: {
    display: 'flex',
  },
  wrapperStatusByItems: {
    alignSelf: 'end',
    marginLeft: '16px',
    borderRadius: '6px',
    display: 'flex',
    marginBottom: '16px',
  },
  wrapperSearchField: {
    marginBottom: '16px',
    border: '1px solid #1D2035',
    borderRadius: '12px',
  },
  wrapperSearchFieldMobile: {
    margin: '0px 0px 16px 16px',
  },
  formControl: {
    minWidth: '66px',
    marginBottom: '2px',
  },
  statusSelect: {
    color: '#F2F4F7',
    height: '40px',
    boxSizing: 'border-box',
    background: '#3BB0FF1A',
    borderRadius: '32px',
    border: '1px solid #3BB0FF26',
    fontFamily: 'Manrope-Regular',
  },
  statusSelectOpen: {
    borderColor: '#3BB0FF',
  },
  chevronIcon: {
    width: '24px',
    height: '24px',
    top: 'calc(50% - 12px) !important',
    right: '8px !important',
  },
  clearIcon: {
    width: '18px',
    height: '18px',
    top: 'calc(50% - 9px) !important',
    right: '12px !important',
    pointerEvents: 'auto !important' as 'auto',
    cursor: 'pointer',
  },
  menuItemRoot: {
    height: '46px',
    fontFamily: 'Manrope-Regular !important',
    fontSize: '16px !important',
    lineHeight: '22px !important',
    fontWeight: 400,
    letterSpacing: 'normal !important',
    color: '#F2F4F7 !important',

    '&:first-child': {
      display: 'none',
    },

    '&:hover': {
      opacity: 1,
    },
  },
  selected: {
    color: '#3BB0FF !important',
    background: 'transparent !important',
  },
}));

export { useStyles };
